module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "actions-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-properties",
      "md-label": "Настройки модуля",
      "to": {
        name: 'Properties',
        params: {
          code: _vm.$route.params.code
        }
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-entities",
      "md-label": "Сущности",
      "to": {
        name: 'Entities',
        params: {
          code: _vm.$route.params.code
        }
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-actions",
      "md-label": "Действия",
      "to": {
        name: 'Actions',
        params: {
          code: _vm.$route.params.code
        }
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a2d9238","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/menu.vue
// module id = 1050
// module chunks = 0